import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  doneMessege: {
    color: theme.palette.secondary.main,
    fontSize: '1.5rem',
    fontWeight: 1000,
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },

  form: {
    '& div': {
      width: '20vw',
    },
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: '20px',
    maxWidth: '360px',
    width: '20vw',
  },

  inputLabel: {
    fontWeight: 500,
  },

  logoContainer: {
    '& img': {
      height: 'auto',
      width: '30vw',
      [theme.breakpoints.down('xs')]: {
        width: '30vw',
      },
    },
  },

  meetingContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(5),
  },

  paymentBtn: {
    maxWidth: '250px',
    width: '100%',
  },

  ScheduleBtnWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    width: '100%',
  },

  textField: {
    backgroundColor: '#fff',
    borderRadius: theme.shape.borderRadius,
    width: '100%',
  },

  verifyLoader: {
    marginLeft: theme.spacing(2),
  },
}));

export default useStyles;
